export default __webpack_public_path__ + "static/media/CN.c8f9e31c.svg";